import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import {MasterLayout} from 'components/layouts/master';
import {CategoriesContainer} from 'components/category';
import _CategoryHeader from './_CategoryHeader.scss';
import {findCategoryInList} from 'base/lib/findCategoryInList';
import {CategoryMenu} from 'components/category';
import {connect} from 'react-redux';

class SubCategories extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      category: [],
      categoryId: this.props.match && this.props.match.params && this.props.match.params.id
    };
  }

  componentDidMount() {
    if (this.props.categories && this.state.categoryId) {
      let matchedCategory = findCategoryInList(this.state.categoryId, this.props.categories);
      this.setState({category: matchedCategory});
      document.title = matchedCategory && matchedCategory.name ? matchedCategory.name : 'DaklakTrade';
    } else {
      document.title = 'DaklakTrade';
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id && nextProps.categories) {
      let matchedCategory = findCategoryInList(nextProps.match.params.id, nextProps.categories);
      this.setState({
        category: matchedCategory || [],
        categoryId: nextProps.match && nextProps.match.params && nextProps.match.params.id
      });
      document.title = matchedCategory && matchedCategory.name ? matchedCategory.name : 'DaklakTrade';
    } else {
      document.title = 'DaklakTrade';
    }
  }

  render() {
    return (
      <MasterLayout>
        <div className="center all-categories">
          <section className="category-header">
            <h1 className="header-title">{this.state.category && this.state.category.name}</h1>
          </section>
          <div className="row">
            <section className="left-content">
              <div className="left-menu">
                <CategoryMenu/>
              </div>
            </section>
            <CategoriesContainer id={this.state.categoryId}/>
          </div>
        </div>
      </MasterLayout>
    );
  }

}

let bindStateToProps = (state) => {
  return {
    categories: state.categoriesAsTree
  };
};

export default connect(bindStateToProps)(SubCategories);



// WEBPACK FOOTER //
// ./pages/sub-categories/SubCategories.jsx